jQuery(function ($) {
    if ($('#contact').length > 0) {
        var defaultEmail = $('#centre').val();

        /**
         * Affichage / masquage des champs selon le sujet choisi
         */
        $('#subject').on('change', function () {
            if ($(this).val() == "Contacter un établissement") {
                $('#zipcode-group').slideDown();
                $('#message').slideUp();
            } else {
                if ($(this).val() == "") {
                    $('#message').slideUp();
                } else {
                    $('#message').slideDown();
                }

                $('#zipcode-group').slideUp();
            }

            $('#center-title').remove();
            $('#centre').val(defaultEmail);
        });

        $('#subject').trigger('change');
        

        /**
         * Clic sur le bouton de recherche d'agences
         */
        $('#contact').on('click', '#displayCenters', function () {
            var zipcode = $('#zipcode').val();

            if (zipcode.length == 5) {
                $('#center-title').remove();

                $.colorbox({
                    href: '/centres-autour-de/?code=' + zipcode,
                    width: "50%",
                    height: "80%",
                    className: "search-centers"
                })
            }
        });

        /**
         * Sélection d'une agence dans la pop-in
         */
        $(document).on('click', '.pick-center', function () {
            $.colorbox.close();

            $('#centre').val($(this).val());
            $('#centre_name').val($(this).data('name'));

            $('#zipcode-group').after(
                $('<p>')
                    .attr('id', 'center-title')
                    .html('Vous avez choisi <strong>' + $(this).data('name') + '</strong>. Relancez une recherche pour changer de centre.')
            );

            $('#message').slideDown();
        });
    }
});